export default {"src":"/_next/static/media/clock-or-timed.edc1b309.svg","height":192,"width":192};